/** @jsx jsx */
import { jsx } from '@emotion/core';

import {
  Placeholder,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { SafePureComponent } from '../../../utils/SafePureComponent';

import { isDesktop } from 'react-device-detect';

class HeroScroller extends SafePureComponent {
  safeRender() {
    const { rendering } = this.props;
    return (
      <section className="hero-scroller-area">
        <Placeholder name="jss-scroller-main" rendering={rendering} />
        <Placeholder
          name="jss-scroller-other-component"
          rendering={rendering}
        />
      </section>
    );
  }
}

HeroScroller.displayName = 'Hero Scroller';

HeroScroller.propTypes = {
  fields: {},
};

export default withSitecoreContext()(HeroScroller);
